export default __webpack_public_path__ + "static/media/avatar.79bfd233.png";